import { render, staticRenderFns } from "./BlackPearlButton.vue?vue&type=template&id=dc70b42c&"
import script from "./BlackPearlButton.vue?vue&type=script&lang=ts&"
export * from "./BlackPearlButton.vue?vue&type=script&lang=ts&"
import style0 from "./BlackPearlButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports